import { SITE_AUTHORIZATION_TOKEN } from '@/config/site'
import * as Endpoints from './generated/apis'
import { querystring } from './utils'
import { Configuration } from './generated'

export class ApiServicePublic {
  config = this._createConfig()

  mktu = new Endpoints.MktuApi(this.config)
  help = new Endpoints.HelpApi(this.config)
  registriesShort = new Endpoints.RegistrySearchSiteApi(this.config)
  document = new Endpoints.DocumentApi(this.config)
  promoCodes = new Endpoints.PublicPromoCodesApi(this.config)

  private _createConfig() {
    return new Configuration({
      basePath: process.env.NEXT_PUBLIC_API_URL.slice(0, -8),
      headers: {
        Accept: 'application/json',
        Authorization: SITE_AUTHORIZATION_TOKEN,
      },
      queryParamsStringify: querystring,
    })
  }
}
